<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Schutz, der nicht beschwert</h2>
        <div class="flex justify-center">
          <h1 class="headline">Überdachungen</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Ob als Wetterschutz für Terrasse, Eingang oder Freisitz: eine Überdachung schafft Raum zum Durchatmen. Sie verlängert die Gartensaison, schützt, was Ihnen wichtig ist, und lässt gleichzeitig Licht und Leichtigkeit zu.
        </p>

        <p class="mt-4 text-gray-700">
          Wir fertigen schlanke, stabile Überdachungen aus Stahl, denn Stahl trägt mehr als herkömmliche Aluminiumkonstruktionen und ermöglicht filigrane Formen ohne Stabilitätsverlust. Für die Eindeckung stehen klare oder matte Glasscheiben zur Auswahl, je nachdem, ob Transparenz oder Sichtschutz gewünscht ist.
        </p>

        <p class="mt-4 text-gray-700">
          Alle Konstruktionen werden feuerverzinkt und können zusätzlich pulverbeschichtet werden, farblich abgestimmt auf Fassade und Umfeld. Wer möchte, ergänzt seine Überdachung um eine passende Beschattung. So entsteht eine langlebige, funktionale Lösung, die sich harmonisch in Ihr Zuhause einfügt und den Aufenthalt im Freien noch ein bisschen schöner macht.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Überdachungen" pixelEvent="FormUeberdachungenSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/ueberdachungen/1.jpg", alt: "Überdachung 1" },
        { src: "img/produkte/ueberdachungen/2.jpg", alt: "Überdachung 2" },
        { src: "img/produkte/ueberdachungen/3.jpg", alt: "Überdachung 3" },
        { src: "img/produkte/ueberdachungen/4.jpg", alt: "Überdachung 4" },
        { src: "img/produkte/ueberdachungen/5.jpg", alt: "Überdachung 5" },
        { src: "img/produkte/ueberdachungen/6.jpg", alt: "Überdachung 6" },
        { src: "img/produkte/ueberdachungen/7.jpg", alt: "Überdachung 7" },
        { src: "img/produkte/ueberdachungen/8.jpg", alt: "Überdachung 8" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
